import bulandiWebApp from "../config/bulandiWebApp.json";
const BULANDI_REGISTRATION_WEB_APP_URL = bulandiWebApp.execUrl;
const BULANDI_WEB_APP_BROWSER_URL =
  process.env.NODE_ENV === "development"
    ? "/bulandi-sheet-exec"
    : BULANDI_REGISTRATION_WEB_APP_URL;
export const bulandi2026Meta = {
  title: "Bulandi 2026",
  date: "2026-07-26",
  venueNote: "Venue and schedule — to be announced",
  mainRegistrationUrl: "",
  scheduleUrl: "",
  workshopRegistrationUrl: "",
  /** Main Bulandi entry (B No.) — false closes new registrations; Events Sign In stays independent. */
  mainRegistrationOpen: false,
  mainRegistrationClosedLabel: "Registration closed",
  /**
   * Bulandi 2026 is over — the page is an archive. Every registration path (main entry,
   * Events Sign In, workshops) is closed and nothing on the page submits anywhere.
   */
  eventConcluded: true,
  eventConcludedLabel: "Registrations closed",
  registrationWebAppUrl: BULANDI_WEB_APP_BROWSER_URL,
  registrationSubmitSecret: "",
  eventRegistrationSpreadsheetId: "1X6wXE1AIpR7edkmmtosGq3z4l0s-fPohOeO8qI45Ig4",
  eventRegistrationSheetGid: "0",
  eventRegistrationSheetFetchUrl: BULANDI_WEB_APP_BROWSER_URL,
};
/** True once Bulandi 2026 has wrapped — see {@link bulandi2026Meta.eventConcluded}. */
export const BULANDI_CONCLUDED = bulandi2026Meta.eventConcluded === true;
export const BULANDI_2026_PATH = "/bulandi-2026";
export const BULANDI_2026_LINKS = {
  home: `${BULANDI_2026_PATH}#home`,
  bulandiRegistration: `${BULANDI_2026_PATH}#bulandi-registration`,
  eventRegistration: `${BULANDI_2026_PATH}#event-registration`,
  workshopRegistration: `${BULANDI_2026_PATH}#workshop-registration`,
  sponsors: `${BULANDI_2026_PATH}#sponsors`,
};
/** SMYM Bulandi helpline — same number as the site footer and registration payment support. */
export const bulandiHelplineWhatsApp = {
  digits10: "8610447053",
  display: "86104 47053",
};
/** Bulandi coordination contacts (reach out on WhatsApp). */
export const bulandiContactCoordinators = [
  "Payal Jhawar",
  "Ketan Bisani",
  "Shubham Sarda",
];
export const bulandiRegistrationUpiQrUrl = "/bulandi_payment.png";
export const bulandiSchedulePdfUrl = "/bulandi_schedule.pdf";
export const bulandiScheduleDownloadFilename = "Bulandi-2026-schedule.pdf";
export const bulandiWorkshopsScheduleImageUrl = "/workshop-schedule.png";
export const bulandiWorkshopsScheduleDownloadFilename =
  "Bulandi-2026-workshops-schedule.png";
export const bulandiRulebookPdfUrl = encodeURI(
  "/Bulandi 2026 Event rule book.pdf",
);
export const bulandiRulebookDownloadFilename =
  "Bulandi-2026-Event-rule-book.pdf";
export const bulandiTitleSponsor = {
  name: "Smt. Kanta Sri J Narayandas Rathi",
  imageUrl: encodeURI("/sponsors/title/Smt. Kanta Sri J Narayandas Rathi.png"),
  websiteUrl: "",
};
export const bulandiPlatinumSponsors = [
  {
    name: "Padmasri Sri Bansilal Rathi M/s GBR Metals Pvt. Ltd.",
    imageUrl: encodeURI("/sponsors/platinium/Padmasri Sri Bansilal Rathi.png"),
    websiteUrl: "",
  },
  {
    name: "Sri Kamal Goidani & Sri Anurag Maheshwari",
    imageUrl: encodeURI(
      "/sponsors/platinium/Sri Kamal Goidani Sri Anurag Maheshwari.png",
    ),
    websiteUrl: "",
  },
  {
    name: "Smt. Saroj Sri Gouri Shankar Rathi",
    imageUrl: encodeURI("/sponsors/platinium/Smt. Saroj Sri Gouri Shankar Rathi.png"),
    websiteUrl: "",
  },
  {
    name: "Smt. Shakuntala Sri Kalyan Singh Mohta",
    imageUrl: encodeURI(
      "/sponsors/platinium/Smt. Shakuntala Sri Kalyan Singh Mohta.png",
    ),
    websiteUrl: "",
  },
  {
    name: "Sri Takhat Singh Sri Rajesh Singh Mohta",
    imageUrl: encodeURI("/sponsors/platinium/Sri Takhat Singh Rajesh Singh Mohta.png"),
    websiteUrl: "",
  },
];
export const bulandiGoldSponsors = [
  {
    name: "Smt Aarti Sri Jaiprakash Malpani",
    imageUrl: encodeURI(
      "/sponsors/gold/Sri Luv Jaiprakash Malpani.png",
    ),
    websiteUrl: "",
  },
  {
    name: "Smt Durgadevi Sri Shyam Sundar Bhootra",
    imageUrl: encodeURI("/sponsors/gold/Smt Durgadevi Sri Shyam Sundar Bhootra.png"),
    websiteUrl: "",
  },
  {
    name: "Seth Ganeshlal Bhikamchand Mundhra Seva Trust",
    imageUrl: encodeURI(
      "/sponsors/gold/Seth Ganeshlal Bhikamchand Mundhra Seva Trust.png",
    ),
    websiteUrl: "",
  },
  {
    name: "Sri Kishore Anirudh Daga",
    imageUrl: encodeURI("/sponsors/gold/Sri Kishore Anirudh Daga.png"),
    websiteUrl: "",
  },
  {
    name: "Malpani Bisani Endowment",
    imageUrl: encodeURI("/sponsors/gold/Malpani Bisani Endowment.png"),
    websiteUrl: "",
  },
  {
    name: "Sri Ratanchand Sri Aditya Daga",
    imageUrl: encodeURI(
      "/sponsors/gold/Sri Ratanchand Sri Aditya Daga.png",
    ),
    websiteUrl: "",
  },
  {
    name: "Sri Satyanarayan Sri Vishal Sri Kunal Bhootra",
    imageUrl: encodeURI(
      "/sponsors/gold/Sri Satyanarayan Sri Vishal Sri Kunal Bhootra.png",
    ),
    websiteUrl: "",
  },
  {
    name: "Smt. Vimala Damani",
    imageUrl: encodeURI(
      "/sponsors/gold/Smt. Vimala Damani.png",
    ),
    websiteUrl: "",
  },
];
export const bulandiAdvisors = [
  {
    name: "Dr. Ashok J Mundhra",
    imageUrl: encodeURI("/sponsors/advisors/Dr. Ashok J Mundhra.png"),
    websiteUrl: "",
  },
];
export { bulandiSubEvents } from "./bulandiSubEventsBulandi2026";
